/* src/puzzle-display.svelte generated by Svelte v4.1.1 */
import {
	SvelteComponent,
	append_styles,
	attr,
	binding_callbacks,
	destroy_each,
	detach,
	element,
	empty,
	ensure_array_like,
	init,
	insert,
	noop,
	safe_not_equal,
	set_custom_element_data,
	set_style,
	space
} from "svelte/internal";

import "svelte/internal/disclose-version";
import { onDestroy, getContext } from 'svelte';
import { defaultContextId, getCurrentSlots } from "core";

function add_css(target) {
	append_styles(target, "svelte-o62gbz", ".image-container.svelte-o62gbz{max-height:80vh;background-size:cover;display:grid}.hidden-zone.svelte-o62gbz{background-color:slateblue}");
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[14] = list[i].gridX;
	child_ctx[15] = list[i].gridY;
	child_ctx[16] = list[i].hidden;
	return child_ctx;
}

// (77:0) {#if puzzle && consent}
function create_if_block(ctx) {
	let cookies_panel;

	function select_block_type(ctx, dirty) {
		if (/*puzzleDataURL*/ ctx[1]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			cookies_panel = element("cookies-panel");
			if_block.c();
			set_custom_element_data(cookies_panel, "loading", "0");
			set_custom_element_data(cookies_panel, "panel-title", "Reveal");
			set_custom_element_data(cookies_panel, "data-testid", /*dataTestid*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, cookies_panel, anchor);
			if_block.m(cookies_panel, null);
			/*cookies_panel_binding*/ ctx[8](cookies_panel);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(cookies_panel, null);
				}
			}

			if (dirty & /*dataTestid*/ 1) {
				set_custom_element_data(cookies_panel, "data-testid", /*dataTestid*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) {
				detach(cookies_panel);
			}

			if_block.d();
			/*cookies_panel_binding*/ ctx[8](null);
		}
	};
}

// (103:2) {:else}
function create_else_block(ctx) {
	let cookies_p;

	return {
		c() {
			cookies_p = element("cookies-p");
			cookies_p.textContent = "Puzzle en cours de chargement..";
		},
		m(target, anchor) {
			insert(target, cookies_p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) {
				detach(cookies_p);
			}
		}
	};
}

// (80:2) {#if puzzleDataURL}
function create_if_block_1(ctx) {
	let cookies_p;
	let t1;
	let div;
	let each_value = ensure_array_like(/*slots*/ ctx[3]);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			cookies_p = element("cookies-p");
			cookies_p.textContent = "Chaque jour, une nouvelle partie de l'image mystérieuse\n\t\t\t\tsera dévoilée. Soyez le premier à deviner ce qu'elle représente.";
			t1 = space();
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div, "class", "image-container svelte-o62gbz");
			set_style(div, "background-image", `url("${/*puzzleDataURL*/ ctx[1]}")`);
			set_style(div, "grid-template-columns", `repeat(puzzleSizeX, 1fr)`);
			set_style(div, "grid-template-rows", `repeat(puzzleSizeY, 1fr)`);
			set_style(div, "aspect-ratio", `${/*imageSize*/ ctx[4][0]}/${/*imageSize*/ ctx[4][1]}`);
		},
		m(target, anchor) {
			insert(target, cookies_p, anchor);
			insert(target, t1, anchor);
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}
		},
		p(ctx, dirty) {
			if (dirty & /*slots*/ 8) {
				each_value = ensure_array_like(/*slots*/ ctx[3]);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*puzzleDataURL*/ 2) {
				set_style(div, "background-image", `url("${/*puzzleDataURL*/ ctx[1]}")`);
			}

			if (dirty & /*imageSize*/ 16) {
				set_style(div, "aspect-ratio", `${/*imageSize*/ ctx[4][0]}/${/*imageSize*/ ctx[4][1]}`);
			}
		},
		d(detaching) {
			if (detaching) {
				detach(cookies_p);
				detach(t1);
				detach(div);
			}

			destroy_each(each_blocks, detaching);
		}
	};
}

// (94:5) {#if hidden}
function create_if_block_2(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.innerHTML = ``;
			attr(div, "class", "hidden-zone svelte-o62gbz");
			set_style(div, "grid-area", `${/*gridX*/ ctx[14]}/${/*gridY*/ ctx[15]}/${/*gridX*/ ctx[14] + 1}/${/*gridY*/ ctx[15] + 1}`);
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*slots*/ 8) {
				set_style(div, "grid-area", `${/*gridX*/ ctx[14]}/${/*gridY*/ ctx[15]}/${/*gridX*/ ctx[14] + 1}/${/*gridY*/ ctx[15] + 1}`);
			}
		},
		d(detaching) {
			if (detaching) {
				detach(div);
			}
		}
	};
}

// (93:4) {#each slots as { gridX, gridY, hidden }}
function create_each_block(ctx) {
	let if_block_anchor;
	let if_block = /*hidden*/ ctx[16] && create_if_block_2(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (/*hidden*/ ctx[16]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) {
				detach(if_block_anchor);
			}

			if (if_block) if_block.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*puzzle*/ ctx[2] && /*consent*/ ctx[6] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*puzzle*/ ctx[2] && /*consent*/ ctx[6]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) {
				detach(if_block_anchor);
			}

			if (if_block) if_block.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
		function adopt(value) {
			return value instanceof P
			? value
			: new P(function (resolve) {
						resolve(value);
					});
		}

		return new (P || (P = Promise))(function (resolve, reject) {
				function fulfilled(value) {
					try {
						step(generator.next(value));
					} catch(e) {
						reject(e);
					}
				}

				function rejected(value) {
					try {
						step(generator["throw"](value));
					} catch(e) {
						reject(e);
					}
				}

				function step(result) {
					result.done
					? resolve(result.value)
					: adopt(result.value).then(fulfilled, rejected);
				}

				step((generator = generator.apply(thisArg, _arguments || [])).next());
			});
	};

	let { dataTestid = undefined } = $$props;
	let { contextId = defaultContextId } = $$props;
	const context = getContext(contextId);
	let puzzleDataURL = null;
	let puzzle = null;
	let slots = null;
	let imageSize = [1, 1];
	let panelElement;
	let consent = context.consentStorage.read();

	const sub = context.puzzleStorage.watchImageDataURL().subscribe(function (value) {
		return __awaiter(this, void 0, void 0, function* () {
			panelElement === null || panelElement === void 0
			? void 0
			: panelElement.setAttribute("loading", "50");

			$$invalidate(4, imageSize = yield context.puzzleStorage.getImageSize(value));
			$$invalidate(1, puzzleDataURL = value);

			panelElement === null || panelElement === void 0
			? void 0
			: panelElement.setAttribute("loading", "100");
		});
	});

	const sub2 = context.puzzleStorage.watch().subscribe(function (p) {
		$$invalidate(2, puzzle = p);
		$$invalidate(3, slots = getCurrentSlots(p, context.dateStorage));
	});

	const sub3 = context.consentStorage.watch().subscribe(function (value) {
		$$invalidate(6, consent = value);

		context.puzzleStorage.readImageDataURL(puzzle).then(function (value) {
			return __awaiter(this, void 0, void 0, function* () {
				if (value) {
					panelElement === null || panelElement === void 0
					? void 0
					: panelElement.setAttribute("loading", "50");

					$$invalidate(4, imageSize = yield context.puzzleStorage.getImageSize(value));
					$$invalidate(1, puzzleDataURL = value);

					panelElement === null || panelElement === void 0
					? void 0
					: panelElement.setAttribute("loading", "100");
				}
			});
		}).catch(console.error);
	});

	context.puzzleStorage.read().then(function (p) {
		$$invalidate(2, puzzle = p);
		$$invalidate(3, slots = p && getCurrentSlots(p, context.dateStorage));

		if (!puzzle) {
			return;
		}

		panelElement === null || panelElement === void 0
		? void 0
		: panelElement.setAttribute("loading", "25");

		return context.puzzleStorage.readImageDataURL(puzzle);
	}).then(function (value) {
		return __awaiter(this, void 0, void 0, function* () {
			if (value) {
				panelElement === null || panelElement === void 0
				? void 0
				: panelElement.setAttribute("loading", "50");

				$$invalidate(4, imageSize = yield context.puzzleStorage.getImageSize(value));
				$$invalidate(1, puzzleDataURL = value);

				panelElement === null || panelElement === void 0
				? void 0
				: panelElement.setAttribute("loading", "100");
			}
		});
	}).catch(console.error);

	onDestroy(() => sub.unsubscribe());
	onDestroy(() => sub2.unsubscribe());
	onDestroy(() => sub3.unsubscribe());

	function cookies_panel_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			panelElement = $$value;
			$$invalidate(5, panelElement);
		});
	}

	$$self.$$set = $$props => {
		if ('dataTestid' in $$props) $$invalidate(0, dataTestid = $$props.dataTestid);
		if ('contextId' in $$props) $$invalidate(7, contextId = $$props.contextId);
	};

	return [
		dataTestid,
		puzzleDataURL,
		puzzle,
		slots,
		imageSize,
		panelElement,
		consent,
		contextId,
		cookies_panel_binding
	];
}

class Puzzle_display extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { dataTestid: 0, contextId: 7 }, add_css);
	}
}

export default Puzzle_display;